{
  "info": "Πληροφορίες",
  "negative": "Σφάλμα",
  "positive": "Επιτυχία"
}
